module.exports = __webpack_public_path__ + "static/media/addIcon.a3ae46a1.svg";